export default "<section>\r\n  <div class=\"pbi-container\">\r\n    <div #reportContainer class=\"report-body\"></div>\r\n  </div>\r\n</section>";